// @ts-nocheck
import { IRoute } from '@umijs/core';
import { AnyAction } from 'redux';
import React from 'react';
import { EffectsCommandMap, SubscriptionAPI } from 'dva';
import { match } from 'react-router-dom';
import { Location, LocationState, History } from 'history';

export * from '/home/user/upos-dev/app/src/models/m_Brand';
export * from '/home/user/upos-dev/app/src/models/m_CashCollections';
export * from '/home/user/upos-dev/app/src/models/m_Catalog';
export * from '/home/user/upos-dev/app/src/models/m_Category';
export * from '/home/user/upos-dev/app/src/models/m_CategoryOption';
export * from '/home/user/upos-dev/app/src/models/m_CategoryOptionGroup';
export * from '/home/user/upos-dev/app/src/models/m_Dashboard';
export * from '/home/user/upos-dev/app/src/models/m_DeliveryConfig';
export * from '/home/user/upos-dev/app/src/models/m_DigitalSignage';
export * from '/home/user/upos-dev/app/src/models/m_FilterForm';
export * from '/home/user/upos-dev/app/src/models/m_Global';
export * from '/home/user/upos-dev/app/src/models/m_Image';
export * from '/home/user/upos-dev/app/src/models/m_InventoryCatalog';
export * from '/home/user/upos-dev/app/src/models/m_InventoryStock';
export * from '/home/user/upos-dev/app/src/models/m_InventoryUOM';
export * from '/home/user/upos-dev/app/src/models/m_Logs';
export * from '/home/user/upos-dev/app/src/models/m_Malls';
export * from '/home/user/upos-dev/app/src/models/m_MallUploadConfig';
export * from '/home/user/upos-dev/app/src/models/m_MallUploadFile';
export * from '/home/user/upos-dev/app/src/models/m_MenuBulkEdit';
export * from '/home/user/upos-dev/app/src/models/m_MenuItem';
export * from '/home/user/upos-dev/app/src/models/m_MenuItemOption';
export * from '/home/user/upos-dev/app/src/models/m_MenuItemOptionGroup';
export * from '/home/user/upos-dev/app/src/models/m_MenuStatus';
export * from '/home/user/upos-dev/app/src/models/m_Outlets';
export * from '/home/user/upos-dev/app/src/models/m_PaymentType';
export * from '/home/user/upos-dev/app/src/models/m_Policy';
export * from '/home/user/upos-dev/app/src/models/m_PolicyGroup';
export * from '/home/user/upos-dev/app/src/models/m_PosDiscount';
export * from '/home/user/upos-dev/app/src/models/m_PosLanguage';
export * from '/home/user/upos-dev/app/src/models/m_PosTerminals';
export * from '/home/user/upos-dev/app/src/models/m_PosVersions';
export * from '/home/user/upos-dev/app/src/models/m_ProductCatalog';
export * from '/home/user/upos-dev/app/src/models/m_Promotions';
export * from '/home/user/upos-dev/app/src/models/m_Reports';
export * from '/home/user/upos-dev/app/src/models/m_RequestLog';
export * from '/home/user/upos-dev/app/src/models/m_Sectors';
export * from '/home/user/upos-dev/app/src/models/m_Setting';
export * from '/home/user/upos-dev/app/src/models/m_Settlement';
export * from '/home/user/upos-dev/app/src/models/m_Staff';
export * from '/home/user/upos-dev/app/src/models/m_Suppliers';
export * from '/home/user/upos-dev/app/src/models/m_Terminals';
export * from '/home/user/upos-dev/app/src/models/m_TransactionItems';
export * from '/home/user/upos-dev/app/src/models/m_Transactions';
export * from '/home/user/upos-dev/app/src/models/m_UserSession';
export * from '/home/user/upos-dev/app/src/models/m_XeroInvoice';
export * from '/home/user/upos-dev/app/src/models/m_XeroInvoiceConfig';
export * from '/home/user/upos-dev/app/src/models/m_XeroMapping';
export * from '/home/user/upos-dev/app/src/models/m_XeroUser';

export interface Action<T = any> {
  type: T
}

export type Reducer<S = any, A extends Action = AnyAction> = (
  state: S | undefined,
  action: A
) => S;

export type ImmerReducer<S = any, A extends Action = AnyAction> = (
  state: S,
  action: A
) => void;

export type Effect = (
  action: AnyAction,
  effects: EffectsCommandMap,
) => void;

/**
 * @type P: Type of payload
 * @type C: Type of callback
 */
export type Dispatch<P = any, C = (payload: P) => void> = (action: {
  type: string;
  payload?: P;
  callback?: C;
  [key: string]: any;
}) => any;

export type Subscription = (api: SubscriptionAPI, done: Function) => void | Function;

export interface Loading {
  global: boolean;
  effects: { [key: string]: boolean | undefined };
  models: {
    [key: string]: any;
  };
}

/**
 * @type P: Params matched in dynamic routing
 */
export interface ConnectProps<
  P extends { [K in keyof P]?: string } = {},
  S = LocationState,
  T = {}
> {
  dispatch?: Dispatch;
  // https://github.com/umijs/umi/pull/2194
  match?: match<P>;
  location: Location<S> & { query: T };
  history: History;
  route: IRoute;
}

export type RequiredConnectProps<
  P extends { [K in keyof P]?: string } = {},
  S = LocationState,
  T = {}
  > = Required<ConnectProps<P, S, T>>

/**
 * @type T: React props
 * @type U: match props types
 */
export type ConnectRC<
  T = {},
  U = {},
  S = {},
  Q = {}
> = React.ForwardRefRenderFunction<any, T & RequiredConnectProps<U, S, Q>>;

